var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-bar"},[_c('v-app-bar',{staticClass:"primary",attrs:{"app":"","flat":""}},[_c('v-spacer'),_c('h4',{staticClass:"white--text"},[_vm._v(" အက်ဒမင်အကောင့်ဝင်ရန် ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }